/** Question helpers for Validation walkthroughs. */

export function isQuestionRequired(question) {
  return Boolean(question?.isRequired);
}

/** Questions for a video (one set per video / group of sections). */
export function flattenVideoQuestions(video) {
  return (video?.questions || []).slice().sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
}

export function buildAnswerMap(submissionDetail) {
  const map = {};
  (submissionDetail?.videos || []).forEach((video) => {
    (video.questions || []).forEach((question) => {
      map[question.questionId] = question.answerText == null ? '' : String(question.answerText);
    });
  });
  return map;
}
